import axios from 'axios'

const backend = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production'
      ? 'https://lighttrack-3dca11eb80d5.herokuapp.com/'
      : 'http://localhost:8080/'
})


//hello triggering
backend.interceptors.request.use(
  (config) => {
    let user = ''
    if (!user)
      user = localStorage?.getItem('user')
        ? JSON.parse(localStorage.getItem('user'))
        : null
    if (user) config.headers = { Authorization: `Bearer ${user.token}` }
    return config
  },
  (error) => Promise.reject(error)
)

export default backend
